import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const FORM_DEFAULTS = {
    action: "/api/form",
    method: "POST",
    showName: true,
    showEmail: true,
    showMessage: true,
    nameLabel: "Name",
    emailLabel: "Email",
    messageLabel: "Message",
    buttonText: "Send",
    buttonVariant: "primary",
};
const FIELD_STYLE = "display:block;margin-bottom:14px;font-family:inherit";
const LABEL_STYLE = "display:block;font-size:14px;font-weight:500;margin-bottom:6px;color:#111";
const INPUT_STYLE = "width:100%;padding:10px 12px;border:1px solid #d4d4d8;border-radius:8px;font:inherit;font-size:15px;line-height:1.4;background:#fff;color:#111;box-sizing:border-box";
const BUTTON_VARIANT_STYLES = {
    primary: "background:#111;color:#fff;border:1px solid #111",
    secondary: "background:#fff;color:#111;border:1px solid rgba(17,17,17,0.2)",
};
function field(name, label, tag, type) {
    const input = tag === "textarea"
        ? `<textarea name="${escapeAttr(name)}" rows="4" required style="${INPUT_STYLE};resize:vertical;min-height:96px"></textarea>`
        : `<input type="${escapeAttr(type)}" name="${escapeAttr(name)}" required style="${INPUT_STYLE}">`;
    return `<label style="${FIELD_STYLE}"><span style="${LABEL_STYLE}">${escapeHtml(label)}</span>${input}</label>`;
}
export const formWidget = {
    type: "form",
    defaultProps: FORM_DEFAULTS,
    renderHtml(props) {
        const parts = [];
        if (props.showName)
            parts.push(field("name", props.nameLabel, "input", "text"));
        if (props.showEmail)
            parts.push(field("email", props.emailLabel, "input", "email"));
        if (props.showMessage)
            parts.push(field("message", props.messageLabel, "textarea", "text"));
        const buttonStyle = [
            "display:inline-block",
            "padding:10px 20px",
            "border-radius:8px",
            "font-weight:500",
            "font:inherit",
            "line-height:1.2",
            "cursor:pointer",
            BUTTON_VARIANT_STYLES[props.buttonVariant],
        ].join(";");
        return `<form class="emk-form" action="${escapeAttr(props.action)}" method="${props.method}" novalidate>${parts.join("")}<button type="submit" style="${buttonStyle}">${escapeHtml(props.buttonText)}</button></form>`;
    },
};
//# sourceMappingURL=form.js.map